import { render, staticRenderFns } from "./RoomAdminCard.vue?vue&type=template&id=7c6d05fb&"
import script from "./RoomAdminCard.vue?vue&type=script&lang=ts&"
export * from "./RoomAdminCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports